import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { db } from './../../Firebase'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';



const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: '25px',
        flexGrow: 1,
        width: '90%',
        margin: 'auto',
        paddingBottom: '25px',
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    paperLegal: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        minHeight: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
function ZF() {
    const classes = useStyles();
    //Data
    const [data, setData] = useState(null)
    // Get data from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('Legal')
            .onSnapshot(snapshot => {
                setData(snapshot.data())
            }
            )
    }, [])
    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                {/*Zonas Francas */}

                <Grid item xs={12} sm={6} lg={6}>
                    <Paper className={classes.paperLegal}>
                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={classes.root}>

                            <ListItem>
                                {data?.ZonasFrancasPermanentes && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{data.ZonasFrancasPermanentes[0]}</h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Zonas Francas Permanentes" />
                            </ListItem>
                        </List>

                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} lg={6}>
                    <Paper className={classes.paperLegal}>
                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            className={classes.root}>

                            <ListItem>
                                {data?.ZonasFrancasUniempresariales && (
                                    <ListItemIcon>
                                        <h1 className="legal-number">{data.ZonasFrancasUniempresariales[0]}</h1>
                                    </ListItemIcon>
                                )}
                                <ListItemText primary="Zonas Francas Uniempresariales" />
                            </ListItem>
                        </List>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default ZF
